import Accordion from "react-bootstrap/Accordion";
import Alert from "react-bootstrap/Alert";
import { resources } from "@constants/hardcoded-strings";
import { ErrorAlert } from "../../../common/error-alert/error-alert";
import styles from "./workflow-import-validation-container.less";
import { EntityImportValidationError } from "@idw-types/data/entity-import-validation-error";
import { generateImportErrorMessages } from "@utils/entity-import/entity-import-util";

type WorkflowImportValidationContainerProps = {
    importErrors: { [key: string]: Array<EntityImportValidationError> };
    jsonContent: { [key: string]: any };
};

export const WorkflowImportValidationContainer = (props: WorkflowImportValidationContainerProps) => {
    const { importErrors, jsonContent } = props;

    const resource = resources.modals.addVerificationWorkflow;

    return (
        <div className={styles.validationContainer}>
            <hr />
            {Object.keys(importErrors).length === 0 && (
                <Alert className={styles.successAlert} variant={"success"}>{resource.validationPassed}</Alert>
            )}
            {Object.keys(importErrors).length > 0 && (
                <>
                    <p><b>{resource.importErrors.header}</b></p>
                    {Object.keys(importErrors).map((serviceId, index) => {
                        const serviceErrorList = generateImportErrorMessages(importErrors[serviceId]);

                        const jsonService = (jsonContent.rpServices || []).find((service: any) => service.id === serviceId);
                        const serviceName = jsonService ? `(${jsonService.serviceName})` : "";

                        const headerString = serviceId ? `Service ID: ${serviceId} ${serviceName}` : `Workflow`;

                        return (
                            <Accordion
                                className={styles.serviceValidationContainer}
                                defaultActiveKey={"0"}
                                key={`workflow-import-error-service-${index}`}
                            >
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>{headerString}</Accordion.Header>
                                    <Accordion.Body>
                                        {serviceErrorList.map((se, seIndex) => (
                                            <ErrorAlert key={`service-${serviceId}-error-${seIndex}`}>
                                                <span key={`import-error-${seIndex}`}>{se}</span>
                                            </ErrorAlert>
                                        ))}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        );
                    })}
                    <p><b>{resource.importErrors.footer}</b></p>
                </>
            )}
        </div>
    );
};